import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Moment } from "moment";

export const formatDate = (date: Moment): string | null => {
    return !!date ? date.format('YYYY-MM-DD') : null;
}

export const formatNgbDate = (date: NgbDateStruct): string | null => {
    return date ? date.year + '-' + ("00" + date.month).slice(-2) + '-' + ("00" + date.day).slice(-2)  : '';
}

export const parseNgbDate = (dateString: string | undefined): NgbDateStruct | null => {
    if (!dateString) {
      return null;
    }
  
    const parts = dateString.split('/');
    if (parts.length !== 3) {
      return null;
    }
  
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
  
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return null;
    }
  
    return { day, month, year };
}

export const decodeFlag = (flag: string): boolean => {
    return flag === 'Y';
}

export const encodeFlag = (flag: boolean | undefined): string | null => {
    if(flag === undefined) {
        return null;
    }
    return flag ? 'Y' : 'N';
}
